import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Select, MenuItem, Button,
  TextField
} from '@mui/material';

const PaymentStatusDialog = ({
  open, // ← Use this prop properly
  onClose,
  title = "",
  selectedBooking,
  handleUpdateStatus,
  loading = false,
  updateStatus,
  setUpdateStatus,
  setReferenceNumber ,
}) => {

  const getStatusLabel = (status, bookedType) => {
    switch (status) {
      case 1: return 'Completed';
      case 0: return bookedType === 2 ? 'Free (Complementary)' : 'Pending';
      case 2: return 'Failed';
      case 3: return 'Refunded';
      default: return 'Aborted';
    }
  };

  const paymentOptions = [
    { value: '0', label: 'Pending' },
    { value: '1', label: 'Completed' },
    { value: '2', label: 'Failed' },
    { value: '3', label: 'Refunded' },
  ];

  const bookingOptions = [
    { value: '1', label: 'Pending' },
    { value: '2', label: 'Processing' },
    { value: '3', label: 'Completed' },
    { value: '4', label: 'Cancelled' },
  ];

  const options = title.toLowerCase().includes("payment") ? paymentOptions : bookingOptions;
  const isPayment= title.toLowerCase().includes("payment");

  return (
    <Dialog
      open={open} // ← Fixed: Use the actual open prop
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.15)',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
          border: '1px solid rgba(226, 232, 240, 0.8)',
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: '700',
          textAlign: 'center',
          fontSize: '1.4rem',
          color: '#1e293b',
          pb: 1,
          pt: 3,
          background: 'linear-gradient(135deg, #2196F3 0%, #1976d2 100%)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '60px',
            height: '3px',
            background: 'linear-gradient(90deg, #2196F3, #1976d2)',
            borderRadius: '2px',
          },
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ px: 4, py: 3 }}>
        <Box
          sx={{
            textAlign: 'center',
            mb: 4,
            p: 3,
            borderRadius: '12px',
            background: 'linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)',
            border: '1px solid #e2e8f0',
          }}
        >
          <Typography
            variant='body1'
            sx={{
              mb: 2,
              color: '#64748b',
              fontSize: '15px',
              fontWeight: '500',
            }}
          >
            Are you sure you want to update the payment status?
          </Typography>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1.5,
              borderRadius: '8px',
              background:
                'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '2px solid #e2e8f0',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
            }}
          >
            <Typography
              variant='body2'
              sx={{
                color: '#64748b',
                fontSize: '13px',
                fontWeight: '500',
              }}
            >
              Booking ID:
            </Typography>
            <Typography
              variant='body1'
              sx={{
                fontWeight: '700',
                color: '#1e293b',
                fontSize: '15px',
                fontFamily: 'monospace',
              }}
            >
              {selectedBooking?.booking_serial_no}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography
            variant='body2'
            sx={{
              mb: 2,
              fontWeight: '600',
              color: '#2196F3',
              fontSize: '13px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {isPayment?"Current Payment Status":"Current Booking Status"}  
          </Typography>
          <Box
            sx={{
              p: 2.5,
              borderRadius: '10px',
              background:
                'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              border: '2px solid #e2e8f0',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
            }}
          >
            <Typography
              variant='body1'
              sx={{
                color: '#1e293b',
                fontSize: '15px',
                fontWeight: '600',
                textAlign: 'center',
              }}
            >
              {getStatusLabel(selectedBooking?.payment_status, selectedBooking?.booked_type)}
            </Typography>
          </Box>
        </Box>

        <Box>
          <Typography
            variant='body2'
            sx={{
              mb: 2,
              fontWeight: '600',
              color: '#2196F3',
              fontSize: '13px',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
               {isPayment? " New Payment Status *":" New Booking Status *"}  
           
          </Typography>

          <Select
            value={updateStatus}
            onChange={(e) => setUpdateStatus(e.target.value)}
            fullWidth
            variant='outlined'
            displayEmpty
            sx={{
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
              '& .MuiOutlinedInput-root': {
                borderRadius: '10px',
                borderColor: '#e2e8f0',
                borderWidth: '2px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  borderColor: '#2196F3',
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.15)',
                },
                '&.Mui-focused': {
                  borderColor: '#2196F3',
                  boxShadow: '0 4px 12px rgba(33, 150, 243, 0.25)',
                },
              },
              '& .MuiSelect-select': {
                fontSize: '15px',
                fontWeight: '500',
                color: '#1e293b',
                py: 2,
              },
              '& .MuiMenuItem-root': {
                fontSize: '15px',
                fontWeight: '500',
              },
            }}
          >
            {options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {title.toLocaleLowerCase().includes("payment") && (
          <Box sx={{ my: 2 }}>
            <Typography
              variant='body2'
              sx={{
                mb: 2,
                fontWeight: '600',
                color: '#2196F3',
                fontSize: '13px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px',
              }}
            >
              Payment Reference Number  *
            </Typography>

            <TextField
              label={"Refernce Number"}
              
              name='payment_refrence_number'
              onChange={(e) => setReferenceNumber?.(e.target.value)}
              fullWidth

            />



          </Box>

        )}
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'end',
          px: 4,
          py: 3,
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          borderTop: '1px solid #e2e8f0',
          gap: 2,
        }}
      >
        <Button
          onClick={()=>{
                setReferenceNumber?.("");
              onClose();
          }}
          className='handle-back'
          variant='outlined'
          sx={{
            borderRadius: '10px',
            minWidth: '120px',
            py: 1.5,
            textTransform: 'uppercase',
            fontSize: '13px',
            fontWeight: '600',
            letterSpacing: '0.5px',
            color: '#64748b',
            borderColor: '#cbd5e1',
            borderWidth: '2px',
            background: '#ffffff',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
            transition: 'all 0.3s ease',
            '&:hover': {
              borderColor: '#94a3b8',
              backgroundColor: '#f8fafc',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
              transform: 'translateY(-1px)',
            },
          }}
        >
          Cancel
        </Button>

        <Button
          onClick={handleUpdateStatus}
          variant='contained'
          disabled={loading}
          className='handle-submit'
          sx={{
            borderRadius: '10px',
            minWidth: '160px',
            py: 1.5,
            textTransform: 'uppercase',
            fontSize: '13px',
            fontWeight: '700',
            letterSpacing: '0.5px',
            background: 'linear-gradient(135deg, #ed6c02 0%, #f57c00 100%)',
            color: '#ffffff',
            boxShadow: '0 4px 16px rgba(237, 108, 2, 0.4)',
            transition: 'all 0.3s ease',
            '&:hover': {
              background:
                'linear-gradient(135deg, #f57c00 0%, #ef6c00 100%)',
              boxShadow: '0 6px 20px rgba(237, 108, 2, 0.5)',
              transform: 'translateY(-2px)',
            },
            '&:disabled': {
              background:
                'linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%)',
              color: '#64748b',
              boxShadow: 'none',
              transform: 'none',
            },
          }}
        >
          {loading ? 'Updating...' : 'Update Status'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentStatusDialog;